/*
 * @description:
 * @author: Jason Wong
 * @since: 2019-07-15 17:20:55
 */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
import HomeRoute from "@/router/modules/home";
import { loginRoute, registerRoute, forgotPasswordRoute ,inviteLinkRoute,userAgreementRoute,privacyPolicyRoute } from "./modules/account";
import { mainRoute, catEditorRoute, alignmentEditorRoute } from "./modules/CAT";
import NotFound from "../views/NotFound.vue";
import testRoute from "./modules/test";
import noticeRouter from "./modules/notice";
import tenantRouter from "./modules/tenantManager";
import teamRouter from "./modules/teamManager";
import systemRouter from "./modules/systemManager";
import { dataPoints } from "./modules/dataPoints";
import { useGuard } from "./guard";

var routes = [
  loginRoute,
  tenantRouter,
  registerRoute,
  inviteLinkRoute,
  forgotPasswordRoute,
  userAgreementRoute,
  privacyPolicyRoute,
  mainRoute,
  catEditorRoute,
  teamRouter,
  systemRouter,
  alignmentEditorRoute,
  HomeRoute,
  testRoute,
  noticeRouter,
  dataPoints,
  {
    path: "/",
    redirect: { name: "homeIndex" },
  },
  {
    path: "*",
    component: NotFound,
  },
];

const router = new Router({
  mode: "history",
  routes,
});
useGuard(router);
export default router;
